import { render, staticRenderFns } from "./OfferHistoryTable.vue?vue&type=template&id=63863ae4&scoped=true"
import script from "./OfferHistoryTable.vue?vue&type=script&lang=ts"
export * from "./OfferHistoryTable.vue?vue&type=script&lang=ts"
import style0 from "./OfferHistoryTable.vue?vue&type=style&index=0&id=63863ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63863ae4",
  null
  
)

export default component.exports